import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

/* js imports */
import useCheckPathName from "../utils/useCheckPathname";
import { videosCurtainAnime } from "../assets/js/animations";

/* img imports */
import videoSeats from "../assets/images/videos/videos-seats.png";
import videosLeftCurtain from "../assets/images/videos/videos-curtain-left.png";
import videosRightCurtain from "../assets/images/videos/videos-curtain-right.png";
import ytThumb from "../assets/images/videos/yt-icon-thumb.png";

/* data import */

import ytVideoData from "../data/youtubeVideoData";
import BackArrow from "../components/BackArrow";
import PageTransition from "../components/PageTransition";
import MainDisclaimerModal from "../components/modals/MainDisclaimerModal";

const Videos = () => {
  useCheckPathName();
  const navigate = useNavigate();
  const handleRedirect = (pageName) => {
    navigate(pageName);
  };
  const handleVideoPreview = (videoId) => {
    const previewWrapper = document.getElementById("ytPreviewWrapper");
    previewWrapper.classList.remove("d-none");
    const iframe = previewWrapper.querySelector("iframe");
    iframe.classList.remove("d-none");
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
  };

  const closePreview = () => {
    const previewWrapper = document.getElementById("ytPreviewWrapper");
    previewWrapper.classList.add("d-none");
    const iframe = previewWrapper.querySelector("iframe");
    iframe.classList.add("d-none");
    iframe.src = "";
  };

  return (
    <>
      <PageTransition />
      <BackArrow handleRedirect={handleRedirect} linkName="/inner-tents" />
      <div className="page-main-wrapper video-page-main-wrapper">
        <div className="videos-screen-wrapper">
          {ytVideoData.length > 0 &&
            ytVideoData.map((item, ind) => (
              <div className="video-thumb-main-wrapper" key={ind}>
                <div
                  className="video-thumb-img-wrapper"
                  onClick={() => handleVideoPreview(item.youtubeLink)}
                >
                  <img src={ytThumb} className="yt-thumb" alt="" />
                  <img
                    src={`https://i.ytimg.com/vi/${item.youtubeLink}/maxresdefault.jpg`}
                    className="main-thumb"
                    alt=""
                  />
                </div>
                <div className="video-practice-link">
                  <a
                    href={item.practiceLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.drName}{" "}
                    <span className="material-symbols-rounded ms-1">
                      open_in_new
                    </span>
                  </a>
                </div>
              </div>
            ))}
        </div>
        <div className="yt-preview-wrapper d-none" id="ytPreviewWrapper">
          <div className="video-close-icon" onClick={closePreview}>
            <span className="material-symbols-rounded">close</span>
          </div>
          <iframe
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen={true}
          ></iframe>
        </div>
        <motion.div
          className="videos-curtain-wrapper videos-left-curtain"
          variants={videosCurtainAnime}
          initial="initial"
          whileInView="animate"
        >
          <img src={videosLeftCurtain} alt="" />
        </motion.div>
        <motion.div
          className="videos-curtain-wrapper videos-right-curtain"
          variants={videosCurtainAnime}
          initial="initial"
          whileInView="animate"
        >
          <img src={videosRightCurtain} alt="" />
        </motion.div>
        <div className="videos-seats-wrapper">
          <img src={videoSeats} alt="" />
        </div>
        <MainDisclaimerModal />
      </div>
    </>
  );
};

export default Videos;
